import { Row, Col, Form, FormCheck } from "react-bootstrap";
import {
  useGetAllParentalRatingQuery,
} from "../../slices/adminApiSlice";

const PlaylistsParentalGuidance = ({
  programDetails,
  setProgramDetails,
  setFormEdited,
  isLocked,
}) => {
  const {
    data: parentalRating,
    isLoading: parentalRatingLoading,
    isError: parentalRatingError,
  } = useGetAllParentalRatingQuery();

  return (
    <>
      <Row className="align-items-center pt-2 ">
        <Col xs={3}>Parental Guidance: </Col>
        <Col>
          <Form.Select
            value={programDetails.parentalrating.parentalrating || ""}
            // xs="2"
            size="sm"
            id="parentalrating"
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                parentalrating: {
                  ...programDetails.parentalrating,
                  parentalrating: e.target.value,
                  isDirty: true,
                },
              });
              setFormEdited(true);
            }}
            disabled={isLocked}
            className={programDetails.parentalrating.isDirty && "text-danger"}
          >
            <option value="">Select Parental Rating</option>
            {parentalRatingLoading && "Loading Parental Ratings..."}
            {parentalRatingError && "Error loading Parental Ratings"}
            {parentalRating &&
              parentalRating.map((rating) => (
                <option
                  key={rating._id}
                  value={rating._id}
                >
                  {rating.rating}
                </option>
              ))}
          </Form.Select>
        </Col>
        <Col sm="1">
          <FormCheck
            type="checkbox"
            isValid
            checked={programDetails.parentalrating.isDirty}
            id="parentalratingisDirty"
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                parentalrating: {
                  ...programDetails.parentalrating,
                  isDirty: e.target.checked,
                },
              });
              setFormEdited(true);
            }}
            disabled={isLocked}
          />
        </Col>
      </Row>
    </>
  );
};
export default PlaylistsParentalGuidance;
